import { createContext } from 'react'

export const BelongingsContext = createContext({
  data: [],
  onUse: () => {}
})
